import {
  Error,
  Insertusersubdash,
  Getusersubdash,
  Insertusersubdashside,
  Getusersubside,
  Insertemailtry,
  UpdateQoute,
  GetQoutsdashh,
  Updatesqouteuserr,
  GetQoutssidee,
  Updateuserdashside,
} from "../type";
const initialState = {
  Createusersubdash: [],
  Createusersubside: [],
  Oneusersupside: [],
  Oneusersupdash: [],
  Updatesqoute: [],
  Updatesqouteuser: [],
  GetQoutsdash: [],
  GetQoutside: [],
  Emailtry: [],
  UpdateSubDashboard: [],
  loading: false,
};
const UserSubscriptionR = (state = initialState, action) => {
  switch (action.type) {
    case Getusersubside:
      return {
        ...state,
        Oneusersupside: action.payload,
        loading: false,
      };
    case Updateuserdashside:
      return {
        UpdateSubDashboard: action.payload,
        loading: false,
      };
    case GetQoutsdashh:
      return {
        ...state,
        GetQoutsdash: action.payload,
        loading: false,
      };
    case GetQoutssidee:
      return {
        ...state,
        GetQoutside: action.payload,
        loading: false,
      };
    case Getusersubdash:
      return {
        Oneusersupdash: action.payload,
        loading: false,
      };
    case UpdateQoute:
      return {
        Updatesqoute: action.payload,
        loading: false,
      };
    case Updatesqouteuserr:
      return {
        Oneusersupside: state.Oneusersupside,
        Updatesqouteuser: action.payload,
        loading: false,
      };
    case Insertusersubdashside:
      return {
        Oneusersupside: state.Oneusersupside,
        Createusersubside: action.payload,
        loading: false,
      };
    case Insertusersubdash:
      return {
        Createusersubdash: action.payload,
        loading: false,
      };

    case Insertemailtry:
      return {
        loading: false,
        Emailtry: action.payload,
      };
    case Error:
      return {
        loading: false,
        MainAccounts: action.payload,
      };
    default:
      return state;
  }
};
export default UserSubscriptionR;
